import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  CImage,
  CLink,
} from '@coreui/react'
import { removeAllItem } from 'src/libs/utils'

const AppSidebar = ({page, onClick=()=>{}}) => {
  const isMobile = useSelector((state) => state.isMobile)

  const onPress = () => {
    window.scrollTo(1, 1);
    onClick();
  }

  return (
      <div className='menu-wrap'>
          <ul>
              <li><CLink to="/memberinfo" component={NavLink} onClick={onPress}><strong>회원 정보</strong></CLink></li>
              {/* <li><CLink to="/review"      component={NavLink} onClick={onPress} className={page == 'review' ? 'active' : ''}>리뷰</CLink></li> */}
              <li><CLink href="/memberinfo" onClick={onPress}
                         className={page === 'memberinfo' ? 'active' : ''}>나의 정보 <CImage src='/img/i_next.png'
                                                                                       className='w-10px'/></CLink></li>
              <li><CLink to="/memberlv" component={NavLink} onClick={onPress}
                         className={page === 'memberlv' ? 'active' : ''}>나의 등급 <CImage src='/img/i_next.png'
                                                                                     className='w-10px'/></CLink></li>
          </ul>
          <hr/>
          <ul>
              <li><CLink to="/mypage" component={NavLink} onClick={onPress}><strong>쇼핑 정보</strong></CLink></li>
              <li><CLink to="/wish-list" component={NavLink} onClick={onPress}
                         className={page === 'wishlist' ? 'active' : ''}>위시리스트 <CImage src='/img/i_next.png'
                                                                                       className='w-10px'/></CLink></li>
              <li><CLink to="/cart" component={NavLink} onClick={onPress}
                         className={page === 'cart' ? 'active' : ''}>장바구니 <CImage src='/img/i_next.png'
                                                                                  className='w-10px'/></CLink></li>
              <li><CLink to="/request-list" component={NavLink} onClick={onPress}
                         className={page === 'request-list' ? 'active' : ''}>내 구매목록 <CImage src='/img/i_next.png'
                                                                                            className='w-10px'/></CLink>
              </li>
          </ul>
          <hr/>
          <ul>
              <li><CLink to="/faq" component={NavLink} onClick={onPress}><strong>고객센터</strong></CLink></li>
              {/* <li><CLink to="/inquiry"      component={NavLink} onClick={onPress} className={page == 'inquiry' ? 'active' : ''}>1:1문의</CLink></li> */}
              <li><CLink to="/faq" component={NavLink} onClick={onPress}
                         className={page === 'faq' ? 'active' : ''}>자주묻는질문 <CImage src='/img/i_next.png'
                                                                                  className='w-10px'/></CLink></li>
          </ul>
          <hr/>
          <ul>
              <li><CLink onClick={removeAllItem}><strong>로그아웃</strong></CLink></li>
          </ul>
      </div>
  )
}

AppSidebar.propTypes = {
    page: PropTypes.string,
    onClick: PropTypes.func,
}

export default React.memo(AppSidebar)
